import { render, staticRenderFns } from "./OrderCardBasicData.vue?vue&type=template&id=1e2613e6&scoped=true&"
import script from "./OrderCardBasicData.vue?vue&type=script&lang=ts&"
export * from "./OrderCardBasicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2613e6",
  null
  
)

export default component.exports